var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 20.5V35.5M20 20.5L15.8334 23.8333M20 20.5L24.1667 23.8333M8.39002 15.695C6.8137 16.0917 5.43648 17.0503 4.51711 18.3907C3.59773 19.7312 3.19949 21.3613 3.3972 22.9747C3.5949 24.588 4.37495 26.0737 5.59079 27.1525C6.80663 28.2313 8.37457 28.829 10 28.8333H11.6667",
    stroke: "#00BC67",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3834 12.3967C25.8138 10.141 24.4077 8.18623 22.4503 6.92876C20.4929 5.67129 18.1306 5.20515 15.8422 5.62484C13.5538 6.04453 11.5107 7.31864 10.1269 9.1889C8.74308 11.0592 8.1222 13.3856 8.3901 15.6967C8.3901 15.6967 8.6451 17.1667 9.16677 18",
    stroke: "#00BC67",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3332 28.8333C29.5099 28.8325 30.6731 28.5825 31.7463 28.0998C32.8194 27.617 33.7782 26.9124 34.5594 26.0324C35.3406 25.1525 35.9266 24.117 36.2788 22.9942C36.631 21.8714 36.7414 20.6868 36.6028 19.5182C36.4642 18.3497 36.0796 17.2238 35.4745 16.2146C34.8694 15.2053 34.0573 14.3357 33.0919 13.663C32.1265 12.9902 31.0295 12.5295 29.8732 12.3113C28.7169 12.093 27.5274 12.1221 26.3832 12.3967L24.1665 13",
    stroke: "#00BC67",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.898270af6521bce8d55501743eae56f1.svg";
export { ForwardRef as ReactComponent };